import { useCallback, useEffect, useRef } from 'react';
var STEP_DELAY = 400;
var STEP_TIMEOUT = 70;
export function useSpinButton(props) {
    var _a = props.value, value = _a === void 0 ? NaN : _a, _b = props.min, min = _b === void 0 ? NaN : _b, _c = props.max, max = _c === void 0 ? NaN : _c, _d = props.textValue, textValue = _d === void 0 ? Number.isFinite(value) ? value.toString() : '' : _d, disabled = props.disabled, readOnly = props.readOnly, required = props.required, onIncrement = props.onIncrement, onExtraIncrement = props.onExtraIncrement, onDecrement = props.onDecrement, onExtraDecrement = props.onExtraDecrement, onDecrementToMin = props.onDecrementToMin, onIncrementToMax = props.onIncrementToMax;
    var isInteractive = !(readOnly || disabled);
    var timerRef = useRef();
    var onKeyDown = useCallback(function (event) {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
            return;
        }
        var handlers = {
            ArrowUp: onIncrement,
            // fallback to increment
            PageUp: onExtraIncrement !== null && onExtraIncrement !== void 0 ? onExtraIncrement : onIncrement,
            ArrowDown: onDecrement,
            // fallback to decrement
            PageDown: onExtraDecrement !== null && onExtraDecrement !== void 0 ? onExtraDecrement : onDecrement,
            End: onIncrementToMax,
            Home: onDecrementToMin,
        };
        var handler = handlers[event.key];
        if (handler) {
            event.preventDefault();
            handler();
        }
    }, [
        onIncrement,
        onExtraIncrement,
        onIncrementToMax,
        onDecrement,
        onExtraDecrement,
        onDecrementToMin,
    ]);
    var resetTimer = useCallback(function () { return clearTimeout(timerRef.current); }, []);
    var pressStartHandler = useCallback(function (callback) {
        function repeat(delay) {
            callback === null || callback === void 0 ? void 0 : callback();
            timerRef.current = window.setTimeout(repeat, delay, STEP_TIMEOUT);
        }
        repeat(STEP_DELAY);
    }, []);
    var onIncrementPressStart = useCallback(function () {
        pressStartHandler(onIncrement);
    }, [pressStartHandler, onIncrement]);
    var onDecrementPressStart = useCallback(function () {
        pressStartHandler(onDecrement);
    }, [pressStartHandler, onDecrement]);
    useEffect(function () { return resetTimer; }, [resetTimer]);
    var spinButtonProps = {
        role: 'spinbutton',
        'aria-valuenow': Number.isFinite(value) ? value : undefined,
        // TODO: localize message
        'aria-valuetext': textValue === '' ? 'Empty' : textValue,
        'aria-valuemin': Number.isFinite(min) ? min : undefined,
        'aria-valuemax': Number.isFinite(max) ? max : undefined,
        'aria-disabled': disabled || undefined,
        'aria-readonly': readOnly || undefined,
        'aria-required': required || undefined,
    };
    if (isInteractive) {
        spinButtonProps.onKeyDown = onKeyDown;
    }
    return {
        spinButtonProps: spinButtonProps,
        incrementButtonProps: {
            disabled: !isInteractive,
            onPressStart: onIncrementPressStart,
            onPressEnd: resetTimer,
        },
        decrementButtonProps: {
            disabled: !isInteractive,
            onPressStart: onDecrementPressStart,
            onPressEnd: resetTimer,
        },
    };
}
